import script from "./TeamMember.vue?vue&type=script&setup=true&lang=js"
export * from "./TeamMember.vue?vue&type=script&setup=true&lang=js"

import "./TeamMember.vue?vue&type=style&index=0&id=072a3f6a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-072a3f6a"]])

export default __exports__